import jApi from './jApi';

export default {
  getPrivilegeApp(req) {
    const api = jApi.generateApi();
    return api.get('/dynamic-apps/privelege-application-by-organigram', req)
      .then(res => res.data);
  },
  getPrivilegeAppTable(req) {
    const api = jApi.generateApi();
    return api.get('/dynamic-apps/privelege-application-by-organigram', req)
      .then(res => res);
  },
  getPrivilegePage(params) {
    const api = jApi.generateApi();
    return api.get('/dynamic-apps/privelege-pages-by-organigram', params)
      .then(res => res.data);
  },
  getPrivilegePages(params) {
    const api = jApi.generateApi();
    return api.get('/nocode/studio/dynamic-apps/privilege-application', params)
      .then(res => res.data);
  },
  createPrivilegeApp(params) {
    const api = jApi.generateApi();
    return api.post('/dynamic-apps/studio/privilege-application-by-organigram', params)
      .then(res => res.data);
  },
  createPrivilegePage(params) {
    const api = jApi.generateApi();
    return api.post('/dynamic-apps/studio/privilege-pages-by-organigram', params)
      .then(res => res.data);
  },
  deletePrivilegeApp(params) {
    const api = jApi.generateApi();
    return api.delete(`/dynamic-apps/studio/privilege-application-by-organigram/${params}`)
      .then(res => res.data);
  },
  deletePrivilegePage(params) {
    const api = jApi.generateApi();
    return api.delete(`/dynamic-apps/studio/privilege-pages-by-organigram/${params}`)
      .then(res => res.data);
  },
};



// WEBPACK FOOTER //
// ./src/services/jApiPrivilegePage.js